import * as yup from "yup";

const DatabaseExportSchema = yup.object().shape({
  tenantId: yup.object().nullable(),
});

export { DatabaseExportSchema };
